(function (root, factory) {
	if (typeof define === 'function' && define.amd) {
		define(function() {
			return factory(root);
		});
	} else if (typeof exports === 'object') {
		module.exports = factory;
	} else {
		root.SparTabs = factory(root);
	}
})(this, function (root) {

	'use strict';

	var VERSION = "1.0", settings = {}, callbackObj = {}, defaults = {};

	var bindTabs = function() {
		var $currTab = $(this);
		var $tabsContainer = $currTab.parent();
		var tabSelected = $currTab.data("tab");
		var $currTabContent = $currTab.parents('.j-tab').find(".j-tab__content[data-tab='"+tabSelected+"']");
		var $hiddenComponentsToLoad = $currTabContent.find('.j-hiddenComponent');

		callbackObj = {
			$currTab:$currTab,
			$tabsContainer:$tabsContainer,
			$currTabContent:$currTabContent
		};

		// remove class OPEN from all .j-tabTitle
		$currTab.parent().find('.j-tabTitle').removeClass("open");
		// add class open to current tab
		$currTab.addClass("open");

		//remove class ACTIVE from all .j-tab__content
		$currTab.parents('.j-tab').find('.j-tab__content').removeClass("open");
		//add class ACTIVE to current .j-tab__content
		var $currTabContent = $currTab.parents('.j-tab').find(".j-tab__content[data-tab='"+tabSelected+"']");
		$currTabContent.addClass("open");

		PTR.lazyloading.getComponents($hiddenComponentsToLoad,successCallback,refreshCallback);
	};

	var successCallback = function(componentsResponse) {
		callbackObj.$currTabContent.append(componentsResponse);
		SPAR.cmscomponents.bindAll();
		horizontalTabScroll();
		window.helpers.scrollTo(callbackObj.$currTab.closest('.j-onlyTab'));
	};

	var refreshCallback = function() {
		var $carousels = callbackObj.$currTabContent.find('.slick-initialized');
		SlickCarouselModule.refresh($carousels);
		Imgness.refresh();
		horizontalTabScroll();
		window.helpers.scrollTo(callbackObj.$currTab.closest('.j-onlyTab'));
	};

	var horizontalTabScroll = function() {
		var elementWidth, left, num, scrollLeft, scroller_width, w, duration, tabsNumber;

		tabsNumber = callbackObj.$tabsContainer.find('.j-tabTitle').length;
		scroller_width = Math.round(callbackObj.$tabsContainer.outerWidth());
		scrollLeft = callbackObj.$tabsContainer.scrollLeft();
		w = $(window).width();
		elementWidth = Math.round(callbackObj.$currTab.outerWidth());
		duration = 350;
		num = callbackObj.$currTab.index();
		if (num === 0) {
			left = 0;
		} else if (num === tabsNumber.length-1) {
			left = scroller_width;
		} else {
			left = callbackObj.$currTab.position().left;
			left = (left + scrollLeft) - ((w - elementWidth) / 2);
		}

		callbackObj.$tabsContainer.stop().animate({
			scrollLeft: "" + left
		}, {
			duration: duration,
			easing: 'swing'
		});
	};

	var init = function(options) {
		var $tabs = $(options.selector);
		$tabs.off('click.sparTabs').on('click.sparTabs',bindTabs);
	};

	return {
		VERSION:VERSION,
		init:init
	};

});